import { Brand } from 'modules/products'
import { apiService } from 'shared/api'

import { FilterDictionary } from './types'

const api = apiService()

interface BrandsFilterResponse {
  data: {
    data: Brand[]
  }
}

interface DictionaryFilterResponse {
  data: FilterDictionary[]
}

interface DeliveryDatesFilterResponse {
  data: {
    data: string[]
  }
}

interface UpsellingZoneFilterResponse {
  data: Brand[]
}

interface CategoryPayload {
  productCategoryId: string
}

export const getBrandsDictionaryWithUpsellingZone = async (
  payload: CategoryPayload
): Promise<UpsellingZoneFilterResponse> => {
  if (payload.productCategoryId.includes('upsellingZone')) {
    const response = await api.get(`/brands/${payload.productCategoryId}`)

    return response as UpsellingZoneFilterResponse
  } else {
    const response = await api.get(`/brands/${payload.productCategoryId}`)

    return response.data as UpsellingZoneFilterResponse
  }
}

export const getBrandsDictionary = async (
  payload: CategoryPayload
): Promise<BrandsFilterResponse> => {
  return api.get(`/brands/${payload.productCategoryId}`)
}

export const getTagsDictionary = (
  payload: CategoryPayload
): Promise<DictionaryFilterResponse> => {
  return api.get(`/tags/${payload.productCategoryId}/product`)
}

export const getDeliveryDatesDictionary =
  (): Promise<DeliveryDatesFilterResponse> => {
    return api.get(`/supported-dates`)
  }
